import React, { PropsWithChildren, useCallback, useContext, useRef } from 'react';

import { CustomBottomSheetModalProvider } from '@/feature/alerts/components/CustomBottomSheetModalProvider';

import { GameResult } from '../GameResultItem';
import { GameResultModalRef, GameResultsModal } from './GameResultsModal';

type GameResultModalContextType = {
    showGameResultModal: (gameResult: GameResult) => void;
};

const GameResultModalContext = React.createContext<GameResultModalContextType | undefined>(undefined);

export const GameResultModalProvider: React.FC<PropsWithChildren> = ({ children }) => {
    const modalRef = useRef<GameResultModalRef>(null);

    const showGameResultModal = useCallback((gameResult: GameResult) => {
        modalRef.current?.show(gameResult);
    }, []);

    return (
        <CustomBottomSheetModalProvider>
            <GameResultModalContext.Provider value={{ showGameResultModal }}>
                {children}
                <GameResultsModal ref={modalRef} />
            </GameResultModalContext.Provider>
        </CustomBottomSheetModalProvider>
    );
};

export const useGameResultModal = () => {
    const context = useContext(GameResultModalContext);
    if (context === undefined) {
        throw new Error('useGameResultModal must be used within a GameResultModalProvider');
    }
    return context;
};
